import { render, staticRenderFns } from "./ForgotPasswordConfirmIdentity.vue?vue&type=template&id=c0616538&"
import script from "./ForgotPasswordConfirmIdentity.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordConfirmIdentity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports